import React from 'react';
import PointListSearchBox from '../PointListSearchBox';
import PointList from '../PointList';
import { POINT_LIST_SORT_OPTION_MODEL } from '../../../../store/modules/point/models';
import { _LIST_PAGINATION_MODEL } from '../../../../store/modules/app/models';

const PointListWrap = (props) => {
  const { setData, pointList, adminSelectList, pointCauseSelectList, getList } = props;

  return (
    <div className="point-list-wrap">
      {/*포인트 내역 검색 박스*/}
      <PointListSearchBox
        pointCauseSelectList={pointCauseSelectList}
        setData={(data) =>
          setData({
            path: ['pointList', 'searchData', ...data.path],
            value: data.value,
          })
        }
        searchData={pointList.searchData}
        adminSelectList={adminSelectList}
        getList={getList}
      />

      {/*포인트 내역 리스트*/}
      <PointList
        pointList={pointList.list}
        initialOption={{
          sortOption: POINT_LIST_SORT_OPTION_MODEL,
          pagination: _LIST_PAGINATION_MODEL,
        }}
        sortOption={pointList.sortOption}
        pagination={pointList.pagination}
        getList={getList}
      />
    </div>
  );
};

export default PointListWrap;
